import {
  toPercentage,
  toFactor,
  toCurrency,
  toCurrencyTruncated,
  toSignificant,
} from '@simplywallst/formatting';

type NilOr<T> = T | null | undefined;

export const isNil = (value: unknown): value is null | undefined =>
  value === null || value === undefined;

export const formatterPercentage = (value: NilOr<number>) =>
  isNil(value) ? 'n/a' : toPercentage(value, 1);

export const formatterFactor = (value: NilOr<number>) =>
  isNil(value) ? 'n/a' : toFactor(value, 1);

export const formatterCurrency = (value: NilOr<number>, currencyISO: string) =>
  isNil(value) ? 'n/a' : toCurrency(value, 2, currencyISO);

export const formatterCurrencyTruncated = (
  value: NilOr<number>,
  currencyISO: string,
  significance = 2
) =>
  isNil(value) ? 'n/a' : toCurrencyTruncated(value, significance, currencyISO);

export const formatterTenure = (value: number | null) =>
  typeof value === 'number' && value > 0
    ? `${toSignificant(value, 2)}yr${value > 1 ? 's' : ''}`
    : 'no data';
